import { ACCOUNT_BASE_PATH, ACCOUNT_PATHS } from '@/shared/lib/routing/account'

export const icon = 'user'
export const humanName = {
  singular: 'Minha conta',
  plural: 'Minha conta'
}

// Os caminhos vivem em `shared/lib/routing` porque o chrome do app também
// depende deles. Reexportados aqui para quem já consome pela feature.
export { ACCOUNT_BASE_PATH, ACCOUNT_PATHS }

export const getConfig = () => {
  const basePath = ACCOUNT_BASE_PATH
  const apiBasePath = `/user`
  const getBreadcrumbs = (breadcrumbs = []) => [
    {
      href: basePath,
      name: humanName.plural
    },
    ...breadcrumbs
  ]

  return {
    basePath,
    apiBasePath,
    forceIdPresence: false,
    icon,
    humanName,
    getBreadcrumbs
  }
}
